<template>
  <div id="container">
    <section id="register">
      <div class="wrap">
        <div class="register_step flex">
          <div class="step_box flex on">
            <div class="num">1</div>
            <p>ゲストユーザー情報の登録</p>
          </div>
          <div class="step_box flex">
            <div class="num">2</div>
            <p>入力内容の確認</p>
          </div>
          <div class="step_box flex">
            <div class="num">3</div>
            <p>ゲストユーザー登録の完了</p>
          </div>
        </div>

        <form @submit="nextClicked">
          <div class="cts_box">
            <h2 class="sub_ttl"><span>ゲストユーザー情報の登録</span></h2>
            <p class="reg_lead">
              <span class="blue bold"
                >「*」のついている箇所は必須項目です。</span
              >
            </p>

            <form-error-box v-if="errors" />

            <div class="input_set name">
              <div class="label">おなまえ<span>*</span></div>
              <div class="input_fields flex">
                <div class="field">
                  <div class="label">姓</div>
                  <input
                    type="text"
                    maxlength="16"
                    v-model="new_user.last_name"
                    v-bind:class="{ error: validation_errors.last_name }"
                    @input="
                      new_user.last_name = replaceHalfToFull(new_user.last_name)
                    "
                    placeholder="例：山田"
                  />
                  <validation-errors
                    :errors="validation_errors.last_name"
                    v-if="validation_errors.last_name"
                  ></validation-errors>
                </div>
                <div class="field">
                  <div class="label">名</div>
                  <input
                    type="text"
                    maxlength="16"
                    v-model="new_user.first_name"
                    v-bind:class="{ error: validation_errors.first_name }"
                    @input="
                      new_user.first_name = replaceHalfToFull(
                        new_user.first_name
                      )
                    "
                    placeholder="例：太郎"
                  />
                  <validation-errors
                    :errors="validation_errors.first_name"
                    v-if="validation_errors.first_name"
                  ></validation-errors>
                </div>
              </div>
            </div>

            <div class="input_set kana">
              <div class="label">フリガナ<span>*</span></div>
              <div class="input_fields flex">
                <div class="field">
                  <div class="label">姓（全角カナ）</div>
                  <input
                    type="text"
                    maxlength="16"
                    v-model="new_user.last_name_kana"
                    v-bind:class="{ error: validation_errors.last_name_kana }"
                    @input="
                      new_user.last_name_kana = replaceHiraToKana(
                        new_user.last_name_kana
                      )
                    "
                    placeholder="例：ヤマダ"
                  />
                  <validation-errors
                    :errors="validation_errors.last_name_kana"
                    v-if="validation_errors.last_name_kana"
                  ></validation-errors>
                </div>
                <div class="field">
                  <div class="label">名（全角カナ）</div>
                  <input
                    type="text"
                    maxlength="16"
                    v-model="new_user.first_name_kana"
                    v-bind:class="{ error: validation_errors.first_name_kana }"
                    @input="
                      new_user.first_name_kana = replaceHiraToKana(
                        new_user.first_name_kana
                      )
                    "
                    placeholder="例：タロウ"
                  />
                  <validation-errors
                    :errors="validation_errors.first_name_kana"
                    v-if="validation_errors.first_name_kana"
                  ></validation-errors>
                </div>
              </div>
            </div>

            <div class="input_set" v-if="false">
              <div class="label">性別<span>*</span></div>
              <div
                class="radio"
                v-bind:class="{ error: validation_errors.gender }"
              >
                <input
                  id="radio01"
                  type="radio"
                  v-model="new_user.gender"
                  value="male"
                />
                <label for="radio01">男性</label>

                <input
                  id="radio02"
                  type="radio"
                  v-model="new_user.gender"
                  value="female"
                />
                <label for="radio02">女性</label>

                <input
                  id="radio03"
                  type="radio"
                  v-model="new_user.gender"
                  value="secret"
                />
                <label for="radio03">その他</label>
              </div>
              <validation-errors
                :errors="validation_errors.gender"
                v-if="validation_errors.gender"
              ></validation-errors>
            </div>

            <div class="input_set birth" v-if="false">
              <div class="label">生年月日<span>*</span></div>
              <p>すべての欄に半角数字でご入力下さい。</p>
              <div class="input_fields flex">
                <div class="field">
                  <input
                    type="text"
                    v-model="new_user.birthday_year"
                    @input="
                      new_user.birthday_year = replaceFullToHalf(
                        new_user.birthday_year
                      )
                    "
                    v-bind:class="{ error: validation_errors.birthday_year }"
                    placeholder="年"
                  />
                  <validation-errors
                    :errors="validation_errors.birthday_year"
                    v-if="validation_errors.birthday_year"
                  ></validation-errors>
                </div>
                <div class="field">
                  <input
                    type="text"
                    v-model="new_user.birthday_month"
                    @input="
                      new_user.birthday_month = replaceFullToHalf(
                        new_user.birthday_month
                      )
                    "
                    v-bind:class="{ error: validation_errors.birthday_month }"
                    placeholder="月"
                  />
                  <validation-errors
                    :errors="validation_errors.birthday_month"
                    v-if="validation_errors.birthday_month"
                  ></validation-errors>
                </div>
                <div class="field">
                  <input
                    type="text"
                    v-model="new_user.birthday_day"
                    @input="
                      new_user.birthday_day = replaceFullToHalf(
                        new_user.birthday_day
                      )
                    "
                    v-bind:class="{ error: validation_errors.birthday_day }"
                    placeholder="日"
                  />
                  <validation-errors
                    :errors="validation_errors.birthday_day"
                    v-if="validation_errors.birthday_day"
                  ></validation-errors>
                </div>
              </div>
            </div>

            <div class="input_set email">
              <div class="label">ユーザーネーム（表示名）<span>*</span></div>
              <p>
                複眼経済塾WEBサイト上で他のゲストユーザーに表示されるお名前です。ログイン後に「マイページ」で変更できます。
              </p>
              <input
                type="text"
                class="nickname"
                v-bind:class="{ error: validation_errors.humhub_username }"
                v-model="new_user.humhub_username"
              />
              <ValidationErrors
                :errors="validation_errors.humhub_username"
                v-if="validation_errors.humhub_username"
              ></ValidationErrors>
            </div>

            <div class="input_set email">
              <div class="label">連絡先メールアドレス<span>*</span></div>
              <input
                type="text"
                class="email"
                v-bind:class="{ error: validation_errors.email }"
                v-model="new_user.email"
              />
              <ValidationErrors
                :errors="validation_errors.email"
                v-if="validation_errors.email"
              ></ValidationErrors>
            </div>

            <div class="input_set email">
              <div class="label">連絡先メールアドレス(確認)<span>*</span></div>
              <input
                type="text"
                class="email"
                v-bind:class="{ error: validation_errors.email_confirmation }"
                v-model="new_user.email_confirmation"
              />
              <ValidationErrors
                :errors="validation_errors.email_confirmation"
                v-if="validation_errors.email_confirmation"
              ></ValidationErrors>
            </div>

            <div class="input_set phone" v-if="false">
              <div class="label">連絡先電話番号<span>*</span></div>
              <p>（半角数字で日中連絡の取れるお電話番号をご入力下さい。）</p>
              <input
                type="tel"
                v-model="new_user.phone_number"
                v-bind:class="{ error: validation_errors.phone_number }"
                @input="
                  new_user.phone_number = replaceFullToHalf(
                    new_user.phone_number
                  )
                "
                placeholder="例：09012345678"
              />
              <validation-errors
                :errors="validation_errors.phone_number"
                v-if="validation_errors.phone_number"
              ></validation-errors>
            </div>

            <div class="input_set">
              <div class="label">パスワード<span>*</span></div>
              <p>（8文字以上の半角英数記号）</p>
              <div class="pswd_box flex">
                <input
                  v-bind:type="password_type ? 'text' : 'password'"
                  v-model="new_user.password"
                  class="password"
                  @input="
                    new_user.password = replaceFullToHalf(new_user.password)
                  "
                  placeholder="8文字以上"
                  v-bind:class="{ error: validation_errors.password }"
                />
                <div class="checkbox">
                  <input
                    id="check01"
                    type="checkbox"
                    v-model="password_type"
                    value="1"
                  />
                  <label for="check01">入力内容を表示</label>
                </div>
              </div>
              <validation-errors
                :errors="validation_errors.password"
                v-if="validation_errors.password"
              ></validation-errors>
            </div>
            <div class="input_set">
              <div class="label">確認のためにもう一度入力<span>*</span></div>
              <p>（8文字以上の半角英数記号）</p>
              <div class="pswd_box flex">
                <input
                  v-bind:type="password_confirmation_type ? 'text' : 'password'"
                  @input="
                    new_user.password_confirmation = replaceFullToHalf(
                      new_user.password_confirmation
                    )
                  "
                  v-model="new_user.password_confirmation"
                  class="password"
                  placeholder="8文字以上"
                  v-bind:class="{
                    error: validation_errors.password_confirmation,
                  }"
                />
                <div class="checkbox">
                  <input
                    id="check02"
                    type="checkbox"
                    v-model="password_confirmation_type"
                    value="1"
                  />
                  <label for="check02">入力内容を表示</label>
                </div>
              </div>
              <validation-errors
                :errors="validation_errors.password_confirmation"
                v-if="validation_errors.password_confirmation"
              ></validation-errors>
            </div>
          </div>

          <div class="cts_box">
            <h2 class="sub_ttl"><span>複眼経済塾を何で知りましたか？</span></h2>

            <div class="input_set survey" v-if="site_knows">
              <div class="label">
                以下の項目からお選びください（複数可）<span>*</span>
              </div>
              <div
                class="checkbox c_red"
                v-for="site_know in site_knows"
                :key="site_know.id"
              >
                <input
                  v-bind:id="'survey_id' + site_know.id"
                  class="checks"
                  type="checkbox"
                  v-model="ids"
                  v-bind:value="site_know.id"
                />
                <label v-bind:for="'survey_id' + site_know.id">{{
                  site_know.name
                }}</label>
              </div>
              <validation-errors
                :errors="validation_errors.questionnaire"
                v-if="validation_errors.questionnaire"
              ></validation-errors>
            </div>

            <p class="alnC sp_alnL mt40 mb20">
              すべての項目に入力後こちらのボタンを押してください。
            </p>
            <div class="button_wrap">
              <input
                type="submit"
                class="submit light arrow"
                value="登録内容の確認"
              />
            </div>
          </div>
        </form>
      </div>
      <!--//.wrap-->
    </section>
  </div>
  <!--//＃container-->
</template>

<script>
import Libraries from "@/components/Libraries.vue";
import ValidationErrors from "@/components/ValidationErrors.vue";
import FormErrorBox from "@/elements/FormErrorBox.vue";

export default {
  mixins: [Libraries],
  components: {
    ValidationErrors,
    FormErrorBox,
  },
  data() {
    return {
      new_user:
        this.$store.state.user && this.$store.state.user.init
          ? this.$store.state.user
          : {
              init: true,
              id: null,
              last_name: null,
              first_name: null,
              last_name_kana: "",
              first_name_kana: null,
              humhub_username: null,
              birthday_year: null,
              birthday_month: null,
              birthday_day: null,
              email: null,
              email_confirmation: null,
              phone_number: null,
              shikiho_account: null,
              gender: null,
              male: null,
              zip: null,
              prefecture: null,
              address1: null,
              address2: null,
              address3: null,
              opt_zip: null,
              opt_address1: null,
              opt_address2: null,
              opt_address3: null,
              enable_primary_address: null,
              password: null,
              password_confirmation: null,
              questionnaire_ids: null,
            },
      show_shikiho_account: false,
      validation_errors: {},
      errors: null,

      password_type: false,
      password_confirmation_type: false,
      site_knows: null,
      ids: [],
    };
  },

  mounted() {
    if (!this.$store.state.user) {
      this.$router.push({
        name: "UsersNewRegistrationFree",
        params: this.$route.params,
      });
      return;
    }

    this.startAjax();
    this.axios
      .get(`${this.env.api_base_url}site_knows.json`)
      .then((response) => {
        // console.log(response.data)
        this.site_knows = response.data.site_knows;
      })
      .catch((response) => {
        this.errorAjax(response);
      })
      .finally(() => {
        this.finishAjax();
      });

    //console.log(this.$store.state.user)
    Object.assign(this.new_user, this.$store.state.user);
    this.$store.state.user = this.new_user;
  },

  methods: {
    nextClicked(event) {
      const keys = [
        "first_name",
        "last_name",
        "first_name_kana",
        "last_name_kana",
        "humhub_username",
        "gender",
        "birthday_year",
        "birthday_month",
        "birthday_day",
        "phone_number",
        "email",
        "email_confirmation",
        "password",
        "password_confirmation",
      ];

      event.preventDefault();
      this.validation_errors = {};
      this.errors = null;
      this.$store.state.user = this.new_user;

      this.new_user.questionnaire_ids = this.ids.join(",");
      this.new_user.password_validates = true;

      this.axios
        .post(`${this.env.api_base_url}users/validate.json`, {
          validate: "free_update",
          user: this.new_user,
        })
        .then(() => {
          //
        })
        .catch((error) => {
          this.scrollTop();
          if (error.response.data.errors) {
            keys.forEach((key) => {
              if (error.response.data.validation_errors[key]) {
                this.validation_errors[key] =
                  error.response.data.validation_errors[key];
                this.errors = true;
              }
            });
          }
          this.$forceUpdate();
        })
        .finally(() => {
          // アンケート
          if (this.ids.length === 0) {
            this.validation_errors["questionnaire"] = [
              "最低1つは選択してください。",
            ];
            this.errors = true;
          }
          if (this.errors) {
            this.scrollTop();
          } else {
            this.$router.push({
              name: "UsersConfirmationFreeConfirm",
              params: this.$route.params,
            });
          }
          this.$forceUpdate();
        });
    },
  },
};
</script>
